/**
 * @generated SignedSource<<88dec4a62b4ae6f78e8dd8d5dcf12c79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type EditSubscriptionTaskInput = {
  environment: ZakekeEnvironment;
  masterSalesChannelID?: string | null;
  secondarySalesChannelID?: string | null;
};
export type salesChannelGenerateEditSubscriptionTaskMutation$variables = {
  input: EditSubscriptionTaskInput;
};
export type salesChannelGenerateEditSubscriptionTaskMutation$data = {
  readonly generateEditSubscriptionTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelGenerateEditSubscriptionTaskMutation = {
  response: salesChannelGenerateEditSubscriptionTaskMutation$data;
  variables: salesChannelGenerateEditSubscriptionTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generateEditSubscriptionTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelGenerateEditSubscriptionTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "salesChannelGenerateEditSubscriptionTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ecdd1b0e8482b849e681822bf6598c4c",
    "id": null,
    "metadata": {},
    "name": "salesChannelGenerateEditSubscriptionTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelGenerateEditSubscriptionTaskMutation(\n  $input: EditSubscriptionTaskInput!\n) {\n  generateEditSubscriptionTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "be06e4362830ebdbeb2066efdbe6c66b";

export default node;
